import * as React from "react";
import Input from "../../Input-new/Input";

const SaleInformation = ({isAgent, data, handleChangeInput, viewMode, deleted, isReferral, isFinancing, isStriveFinancing}) => {
    return (
        <div className="Sale-information">
            <div className="Sale-information_column">
                <Input
                    className="Sale-information_column_item"
                    placeholder="MM/DD/YYYY"
                    type="text"
                    valueType="date"
                    name="CLOSE_OF_ESCROW"
                    label="Close Of Escrow"
                    value={data.CLOSE_OF_ESCROW}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                {
                    isReferral ?
                        <Input
                            className="Sale-information_column_item"
                            type="text"
                            valueType="float"
                            name="REFERRAL_FEE"
                            label="Fee Amount"
                            value={data.REFERRAL_FEE}
                            handleParentChange={handleChangeInput}
                            viewMode={viewMode}
                            deleted={deleted}
                            isDollar
                        />
                        :
                        <React.Fragment>
                            <Input
                                className="Sale-information_column_item"
                                type="text"
                                valueType="integer"
                                name="SOLD_PRICE"
                                label="Price @ Close"
                                value={data.SOLD_PRICE}
                                disabled={isAgent}
                                handleParentChange={handleChangeInput}
                                viewMode={viewMode}
                                deleted={deleted}
                                isDollar
                            />
                            <Input
                                className="Sale-information_column_item"
                                type="text"
                                valueType="percent"
                                name="CLOSE_CAP_RATE"
                                label="Cap Rate @ Close - auto"
                                value={data.CLOSE_CAP_RATE}
                                disabled
                                handleParentChange={handleChangeInput}
                                viewMode={viewMode}
                                deleted={deleted}
                            />
                            <Input
                                className="Sale-information_column_item"
                                type="text"
                                valueType="integer"
                                name="CLOSE_NOI"
                                label="NOI @ Close"
                                value={data.CLOSE_NOI}
                                disabled={isAgent}
                                handleParentChange={handleChangeInput}
                                viewMode={viewMode}
                                deleted={deleted}
                                isDollar
                            />
                            <Input
                                className="Sale-information_column_item"
                                type="text"
                                valueType="float"
                                name="CLOSE_PRICE_PER_SQFT"
                                label="PSF @ Close – auto"
                                value={data.CLOSE_PRICE_PER_SQFT}
                                disabled
                                handleParentChange={handleChangeInput}
                                viewMode={viewMode}
                                deleted={deleted}
                                isDollar
                            />
                            {
                                (isFinancing || isStriveFinancing) &&
                                <Input
                                    className="Sale-information_column_item"
                                    type="text"
                                    valueType="integer"
                                    name="DOWN_PAYMENT"
                                    label="Down Payment"
                                    value={data.DOWN_PAYMENT}
                                    disabled
                                    handleParentChange={handleChangeInput}
                                    viewMode={viewMode}
                                    deleted={deleted}
                                    isDollar
                                />
                            }
                            {
                                isFinancing &&
                                <Input
                                    className="Sale-information_column_item"
                                    type="text"
                                    valueType="integer"
                                    name="LOAN_AMOUNT"
                                    label="Loan Amount"
                                    value={data.LOAN_AMOUNT}
                                    disabled
                                    handleParentChange={handleChangeInput}
                                    viewMode={viewMode}
                                    deleted={deleted}
                                    isDollar
                                />
                            }
                        </React.Fragment>
                }
            </div>
            {
                !isReferral && !isFinancing &&
                <div className="Sale-information_column">
                    <Input
                        className="Sale-information_column_item"
                        type="text"
                        valueType="float"
                        name="LIST_FEE"
                        label="List Fee - auto"
                        value={data.LIST_FEE}
                        disabled
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                        isDollar
                    />
                    <Input
                        className="Sale-information_column_item"
                        type="text"
                        valueType="float"
                        name="BUYSIDE_FEE"
                        label="Buyside Fee - auto"
                        value={data.BUYSIDE_FEE}
                        disabled
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                        isDollar
                    />
                    <Input
                        className="Sale-information_column_item"
                        type="text"
                        valueType="float"
                        name="POTENTIAL_FEE"
                        label="STRIVE Fee - Auto"
                        value={data.POTENTIAL_FEE}
                        disabled
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                        isDollar
                    />
                </div>
            }
        </div>
    );
};

export default SaleInformation;
